import { ColorAA } from "../constants";
import BreakdownBar from "./BreakdownBar";

const getUsedLabel = (count: number) => {
  return count === 1
    ? `${Intl.NumberFormat().format(count)} request used`
    : `${Intl.NumberFormat().format(count)} requests used`;
};

const getRemainingLabel = (count: number) => {
  return count === 1
    ? `${Intl.NumberFormat().format(count)} request remaining`
    : `${Intl.NumberFormat().format(count)} requests remaining`;
};

const getLimitLabel = (count: number) => {
  return count === 1
    ? `${Intl.NumberFormat().format(count)} request max`
    : `${Intl.NumberFormat().format(count)} requests max`;
};

const getExcessLabel = (count: number) => {
  return count === 1
    ? `${Intl.NumberFormat().format(count)} request above limit`
    : `${Intl.NumberFormat().format(count)} requests above limit`;
};

export const RequestUsageBar = ({
  used,
  max,
  backgroundColor,
  borderColor,
}: {
  used: number;
  max: number;
  backgroundColor?: string;
  borderColor?: string;
}) => {
  const remaining = max - used;

  return remaining >= 0 ? (
    <BreakdownBar
      segments={[
        {
          size: used,
          tooltip: getUsedLabel(used),
          borderColor: borderColor,
          fillColor: backgroundColor,
        },
        {
          size: remaining,
          tooltip: getRemainingLabel(remaining),
          borderColor: ColorAA.lightGrey,
          fillColor: ColorAA.lightGrey,
        },
      ]}
    />
  ) : (
    <BreakdownBar
      segments={[
        {
          size: max,
          tooltip: getLimitLabel(max),
          borderColor: ColorAA.pink,
          fillColor: ColorAA.pink,
        },
        {
          size: used - max,
          tooltip: getExcessLabel(used - max),
          borderColor: ColorAA.pink,
          fillColor: ColorAA.pink,
          stripePattern: true,
        },
      ]}
    />
  );
};
